"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixContainer = exports.OverviewMatrixContainer = void 0;
var React = require("react");
var container_1 = require("./container");
var charts_1 = require("./charts");
var stringUtils_1 = require("../lib/stringUtils");
var varTable_1 = require("./varTable");
var OverviewMatrixContainer = (function (_super) {
    __extends(OverviewMatrixContainer, _super);
    function OverviewMatrixContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverviewMatrixContainer.prototype.render = function () {
        var _this = this;
        var matrix = this.props.matrix;
        var evals = matrix.evals;
        var title = interpolate("%s (%s)", [
            matrix.name,
            matrix.is_opportunity ? gettext("Opp.") : gettext("Risk")
        ]);
        return (React.createElement(container_1.Container, { fullWidth: true, key: "".concat(matrix.name, "-").concat(matrix.unit), containerTitle: title }, evals
            .filter(function (evaluation) {
            return _this.props.eval_types.indexOf(evaluation.eval_type.toString()) !== -1;
        })
            .map(function (evaluation, i) {
            return React.createElement(MatrixContainer, { evaluation: evaluation, definitions: matrix.defs, is_opportunity: matrix.is_opportunity, explicit_evaluation: matrix.explicit_evaluation, key: i, number_to_show: _this.props.number_to_show, selected_definition: _this.props.selected_definition, useQuantitative: _this.props.useQuantitative });
        })));
    };
    return OverviewMatrixContainer;
}(React.Component));
exports.OverviewMatrixContainer = OverviewMatrixContainer;
var MatrixContainer = (function (_super) {
    __extends(MatrixContainer, _super);
    function MatrixContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MatrixContainer.prototype.render = function () {
        var matrix = this.props.evaluation;
        var evaluations = matrix.evaluations
            .sort(function (a, b) { return b.var - a.var; });
        if (this.props.number_to_show != "All") {
            evaluations = evaluations.slice(0, parseInt(this.props.number_to_show));
        }
        return (React.createElement(container_1.Container, { borderless: true, key: "".concat(matrix.eval_type), containerTitle: (0, stringUtils_1.capitalizeFirstLetter)(matrix.eval) },
            React.createElement(container_1.Container, { borderless: true },
                React.createElement(charts_1.MatrixPlot, { matrix: matrix, definitions: this.props.definitions, numberToShow: this.props.number_to_show, selected_definition: this.props.selected_definition, useQuantitative: this.props.useQuantitative })),
            React.createElement(container_1.Container, { borderless: true },
                React.createElement(varTable_1.ValueAtRiskTable, { evaluations: evaluations, cross_project: this.props.definitions.length > 1, var_total: matrix.var_total }))));
    };
    return MatrixContainer;
}(React.Component));
exports.MatrixContainer = MatrixContainer;
